import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Slide {
  image: string;
  tag: string;
  title: string;
  subtitle: string;
  to: string;
  cta: string;
}

const slides: Slide[] = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20dark%20navy%20space%20scene%20with%20a%20colossal%20glowing%20teal%20wormhole%20and%20scattered%20stars%2C%20dramatic%20lighting%2C%20deep%20shadows%20on%20the%20left%20side%20for%20text%2C%20abstract%20artistic%20cosmic%20composition%2C%20high%20detail%2C%20moody%20atmospheric%20film%20key%20visual&width=1920&height=1080&seq=qiubu-hero-01&orientation=landscape",
    tag: "穹顶重制 · 本周首映",
    title: "星际穿越·穹顶重制版",
    subtitle: "被整片星空包裹，感受引力的拉扯。8K 激光球幕特别修复场次现已开票。",
    to: "/films/interstellar-remaster",
    cta: "查看影片",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20deep%20sea%20scene%20with%20glowing%20cyan%20bioluminescent%20creatures%20and%20a%20dark%20trench%2C%20volumetric%20light%20rays%2C%20deep%20shadows%20on%20the%20left%20for%20text%2C%20abstract%20artistic%20underwater%20composition%2C%20high%20detail%2C%20moody%20atmospheric%20documentary%20key%20visual&width=1920&height=1080&seq=qiubu-hero-02&orientation=landscape",
    tag: "深海沉浸 · 4K 重制",
    title: "深海奇境",
    subtitle: "潜入海平面以下一万米，让荧光生物环绕你的四周。",
    to: "/films/deep-sea-odyssey",
    cta: "查看影片",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20abstract%20scene%20of%20glowing%20cyan%20and%20orange%20quantum%20energy%20particles%20swirling%20in%20dark%20navy%20space%2C%20dynamic%20motion%2C%20deep%20shadows%20on%20the%20left%20for%20text%2C%20artistic%20sci%20fi%20composition%2C%20high%20detail%2C%20moody%20atmospheric%20key%20visual&width=1920&height=1080&seq=qiubu-hero-03&orientation=landscape",
    tag: "技术专场 · 沉浸叙事",
    title: "量子迷航",
    subtitle: "在平行世界的重叠影像中，转动身体才能看全整个故事。",
    to: "/films/quantum-drift",
    cta: "查看影片",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      {slides.map((slide, i) => (
        <div
          key={slide.title}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              src={slide.image}
              alt={`${slide.title} 球幕影院沉浸式观影现场`}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-background-50/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent" />
        </div>
      ))}

      <div className="relative z-10 w-full h-full max-w-content mx-auto px-4 md:px-8 flex items-center">
        <div key={index} className="max-w-xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-label bg-accent-500/15 text-accent-500 mb-5">
            <i className="ri-sparkling-2-line" />
            {slides[index].tag}
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-foreground-950 leading-tight mb-5">
            {slides[index].title}
          </h1>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8 max-w-lg">
            {slides[index].subtitle}
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to={slides[index].to}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 font-label font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg" />
              {slides[index].cta}
            </Link>
            <Link
              to="/screenings"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300/70 text-foreground-900 font-label hover:bg-background-200/60 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line" />
              查看场次
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute z-10 bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2.5">
        {slides.map((slide, i) => (
          <button
            key={slide.title}
            type="button"
            aria-label={`切换到 ${slide.title}`}
            onClick={() => setIndex(i)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              i === index ? "w-8 bg-accent-500" : "w-3 bg-foreground-700/50 hover:bg-foreground-700"
            }`}
          />
        ))}
      </div>
    </section>
  );
}